import { useRef } from "react";
import DialogWindow from "../../../CommonComponents/DialogWindow/DialogWindow";
import "./DraftSaveDialog.scss";

function DraftSaveDialog(props) {
	const nameRef = useRef("");
	return (
		<DialogWindow
			setOpen={props.setOpenDraftSaveDialog}
			style={{ width: "fit-content" }}
		>
			<form
				className='draft-save-dialog'
				method='post'
				onSubmit={(e) => props.handleAddDraft(e, nameRef.current.value)}
			>
				<input
					ref={nameRef}
					type='text'
					defaultValue={""}
					placeholder='Введите название...'
					maxLength={60}
					required
				/>
				<button type='submit'>Сохранить</button>
				<button onClick={() => props.setOpenDraftSaveDialog(false)}>
					Закрыть
				</button>
			</form>
		</DialogWindow>
	);
}

export default DraftSaveDialog;
